import {getCookie} from '../../_web/utils/cookies'
import {cookieSecuritySettings} from '../../_web/utils/cookies/cookieSecuritySettings'

const name = 'vclid'

/**
 * VCLID cookie configuration. Expiration is supplied per-brand by the caller
 * (see `brand.vclidCookieExpirationHours`) so it can vary at runtime — Kiwi
 * needs 4h while every other brand keeps the 2-year default.
 */
export const vclidCookieConfig = {
  name,
  options: cookieSecuritySettings(true)
}

/**
 * Getting vclid value from cookie
 */
export const getPersistedVclidValue = (): string | undefined => {
  return getCookie(vclidCookieConfig.name)
}
